import {
  FormControl,
  FormLabel,
  FormHelperText,
  Heading,
  Box
} from '@chakra-ui/react';
import React from 'react';
import { ZipperAttributes as za } from 'product-validator';
import { ButtonRadioGroup } from '../../../general/ButtonRadio';
import { AppFieldComponent } from '../../../../types/appFieldTypes';

export const ZipperHardwareTypeField: AppFieldComponent = ({
  setFormField,
  currentValue,
  toNextPage
}) => {
  return (
    <Box maxW="30rem">
      <FormControl as="fieldset">
        <FormLabel as="legend" mb="1.5rem">
          <Heading>Hardware</Heading>
        </FormLabel>
        <ButtonRadioGroup
          name="Zipper Hardware Type"
          value={currentValue.zipperHardwareType}
          options={Object.values(za.ZipperHardwareType)}
          onChange={(v) => {
            setFormField({
              zipperHardwareType: v as za.ZipperHardwareType
            });
            toNextPage({ navOnNextFormUpdate: true });
          }}
        />
        <FormHelperText>Choose one.</FormHelperText>
      </FormControl>
    </Box>
  );
};
